// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"252":"css/app","496":"css/creator-secure-login-mobile"}[chunkId] + ".css";
};